import { render, staticRenderFns } from "./taux-chirurgies.html?vue&type=template&id=70716494&scoped=true&external"
import script from "./taux-chirurgies.js?vue&type=script&lang=js&external"
export * from "./taux-chirurgies.js?vue&type=script&lang=js&external"
import style0 from "./taux-chirurgies.scss?vue&type=style&index=0&id=70716494&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70716494",
  null
  
)

export default component.exports